//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchDetail, evaluate } from '@/api/PMS/repair/repairManagement';
import { fetchListByType } from '@/api/PMS/dic/dic';
export default {
  data: function data() {
    return {
      childData: {// visitRating: '99'
      },
      statueOption: [],
      options: []
    };
  },
  props: ['keyValue', 'showDialog', 'keyData'],
  created: function created() {
    this.childData = {};
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.statueOption = [];
      this.loadAdStatue();

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue,
          flowNum: this.flowNum
        };
        fetchDetail(queryData).then(function (response) {
          _this.childData = response.data.data;
        });
      } else {
        this.childData = {};
      }
    },
    loadAdStatue: function loadAdStatue() {
      var _this2 = this;

      fetchListByType('evaluation_criterion').then(function (r) {
        _this2.statueOption = r.data.data;
      });
    },
    handEvaluate: function handEvaluate() {
      var _this3 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (_this3.keyValue > 0) {
            _this3.childData.repairId = _this3.keyValue;
            _this3.childData.verifyStatus = _this3.childData.flowStatus;
            _this3.childData.visitRating = parseInt(_this3.childData.visitRating);
            evaluate(_this3.childData).then(function () {
              _this3.$emit('handCancle', 'repairEvaluate');

              _this3.Alert({
                alertType: 'update'
              });
            });
          } else {
            _this3.Alert({
              alertType: 'valid'
            });
          }
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', 'repairEvaluate');
    }
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  }
};